import { FormControl, FormErrorMessage, Switch } from "@chakra-ui/react";
import React from "react";
import { Control, Controller, FieldPath, FieldValues, RegisterOptions } from "react-hook-form";
import FormLabelCustom from "./FormLabel";

function SwitchForm<T extends FieldValues = FieldValues>({
  control,
  label,
  rules,
  name,
  placeholder,
  labelProps = {},
  onChange: customChange,
}: {
  control: Control<T>;
  label: string;
  labelProps?: any;
  name: string;
  placeholder?: string;
  rules?: RegisterOptions<any>;
  onChange?: (value: boolean) => void;
}) {
  return (
    <Controller
      control={control}
      name={name as FieldPath<T>}
      rules={rules as RegisterOptions<T, FieldPath<T>>}
      render={({
        field: { onChange, name, value },
        fieldState: { invalid, error },
      }) => (
        <FormControl isInvalid={invalid}>
          <FormLabelCustom label={label} name={name} props={labelProps} />
          <Switch
            defaultValue={value}
            isChecked={value}
            placeholder={placeholder}
            onChange={(data) => {
              if (customChange) {
                customChange(data.target.checked);
              }
              onChange(data);
            }}
            value={value}
            name={name}
          />
          <FormErrorMessage>
            {error?.message || "Campo inválido"}
          </FormErrorMessage>
        </FormControl>
      )}
    />
  );
};

export default SwitchForm;
